import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "./../Context/Auth";

function PrivateRoute({ component: Component, ...rest }) {
  const { isValid } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        isValid ? (
          Component ? (
            <Component {...props} />
          ) : (
            rest.render(props)
          )
        ) : (
          <Redirect to="/404" />
        )
      }
    />
  );
}

export default PrivateRoute;
